import { TAppState, TActionTypes, ActionTypes } from './types'

const INITIAL_STATE: TAppState = {
  key: null,
  orgs: [],
  currentOrg: null,
  fetched: false,
}

export default function reducer(
  state = INITIAL_STATE,
  action: TActionTypes,
): TAppState {
  switch (action.type) {
    case ActionTypes.APP_SET_DATA: {
      return { ...state, ...action.payload }
    }

    case ActionTypes.APP_SET_CURRENT_ORG: {
      return {
        ...state,
        key: action.payload.settings.key,
        currentOrg: action.payload,
      }
    }

    default:
      return {
        ...state,
      }
  }
}
